import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import { AdminPageLayout } from "@/features/admin/components/AdminPageLayout";
import { CourseSetupFlow } from "@/features/admin/course-setup/CourseSetupFlow";
import {
  isCourseSetupStepId,
  type CourseSetupStepId,
} from "@/features/admin/course-setup/courseSetupSteps";

type NewCourseSearchParams = {
  courseId?: string;
  step?: CourseSetupStepId;
  /** "online" once an online course is chosen and before its file is uploaded. */
  type?: "online";
};

export const Route = createFileRoute("/admin/courses/new")({
  component: NewCoursePage,
  validateSearch: (search: Record<string, unknown>): NewCourseSearchParams => ({
    courseId:
      typeof search.courseId === "string" && search.courseId.length > 0
        ? search.courseId
        : undefined,
    step: isCourseSetupStepId(search.step) ? search.step : undefined,
    type: search.type === "online" ? "online" : undefined,
  }),
});

function NewCoursePage() {
  const { courseId, step, type } = Route.useSearch();

  return (
    <ProtectedRoute requiredPermissions={["Courses.Manage"]} requiredRoles={["Admin"]}>
      <AdminPageLayout>
        <CourseSetupFlow courseId={courseId} step={step} type={type} />
      </AdminPageLayout>
    </ProtectedRoute>
  );
}
